// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2EF4U","rootSmall":"AddTileButton_rootSmall__2-wZU"};